import React, { useEffect, useRef, useState } from "react";
import { Dialog, Input, Loader } from "../utils";
import { SearchDropdown, Dropdown } from "../utils";
import { Button } from "../utils";
import { buttonClasses } from "../utils/theme";
import { useCheckpointData, useCheckpoints, usePlant, useTripDetails } from "../../services/hooks";
import { useUpdateManageTripMutation, useModifyTripMutation } from "../../api/api";
import { useCustomizeTripWorkflowMutation, useGetApprovalConfigMutation, useGetApprovalDetailMutation, useVehicleDetailsMutation } from "../../api/vmsSlice";
import { capitalizeCamelCase, capitalizeSentence, findDeepValue, formatDate, isFilePath, parseUnderscore, removeSpecialChars } from "../../services/functions";
import { toastMessage } from "../utils";
import "./Trip.css";
import { useLocation, useNavigate } from "react-router";
import { CloseIcon, SearchIcon } from "../../services/icons";
import DynamicFormRender from "../Dynamic/DynamicForm";
import { useUserDetail } from "../../services/hooks";
import { useUserPermissions } from "../../services/hooks";
import { useGetTripcheckpointMutation } from "../../api/vmsSlice";
import { CheckIcon } from "../../services/icons";
import AllCheckpointData from "../Dashboard/AllCheckpointData";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FilePreview from "../utils/FilePreview";
import { useSearchParams } from "react-router-dom";
import GenericWorkflowUpdate from "../utils/GenericWorkflowUpdate";
import { usePlantContext } from "../../context/plantContext";
// import {  } from "../utils/index";

const defaultFilter = {
	checkpointId: "all",
};

export default function TripIndex() {
	const { plantId } = usePlantContext();
	const filterRef = useRef(defaultFilter);
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const entryId = searchParams.get("entryId");
	const { userPermissions } = useUserPermissions();
	const [isModifying, setIsModifying] = useState(false);
	const [searchVehicle, setSearchVehicle] = useState("");
	const [searchTrigger, setSearchTrigger] = useState(false);
	const [selectedVehicle, setSelectedVehicle] = useState({});
	const [vehicledata, setVehicleData] = useState({});
	const [vehicleTableHeader, setVehicleTableHeader] = useState([]);
	const [allCheckpointList, setAllCheckpointList] = useState([]);
	const [forcedEndTrip, setForcedEndTrip] = useState(false);
	const [cancelTrip, setCancelTrip] = useState(false);
	// const [remarks, setRemarks] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({
		searchBy: "",
		checkpointId: "",
		remarks: "",
	});
	const [logStatus, setLogStatus] = useState({});
	const [tripData, setTripData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const { userDetail } = useUserDetail();
	const [updateCustomizeTripWorkflow] = useCustomizeTripWorkflowMutation();
	// const { trigger, checkpointData, isLoading, isFetching, count, message, error: checkpointError } = useCheckpointData(filterRef.current);
	const { getTripDetail, tripDetail, isLoading, message, error: tripDataError } = useTripDetails();
	const [updateManageTrip] = useUpdateManageTripMutation();
	const [modifyTripTrigger] = useModifyTripMutation();
	const [vehicleDetailTrigger] = useVehicleDetailsMutation();
	const [getTripcheckpointTrigger] = useGetTripcheckpointMutation();
	const location = useLocation();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [historicalDataHeaderMap, setHistoricalDataHeaderMap] = useState({});
	const { checkoutConfigMap } = useCheckpoints();
	const { plants } = usePlant();
	const factoryCoordinatesValue = plants.find((_) => _._id === plantId)?.factoryCoordinates;
	const handleChange = (value, key) => {
		// console.log('value', value, 'key', key);
		setSearchVehicle((previous) => {
			return { [key]: value === null ? "" : value };
		});
	};

	const onhandleClear = () => {
		setSearchTrigger(true);
		setSearchVehicle("");
	};

	const handleOpenNewTab = (data) => {
		// Construct the new URL based on the current location
		const newRoute = "/map-view"; // Replace with your desired route
		const newUrl = `${window.location.origin}${newRoute}?data=${encodeURIComponent(data)}`;

		// Open the new route in a new tab
		window.open(newUrl, "_blank");
	};

	const onHandleSearch = () => {
		// console.log('search', searchVehicle);
		setIsModifying(false);
		// convertTextToSpeech(JSON.stringify(searchVehicle));
		if (!searchVehicle) {
			setError({ ...error, searchBy: "Please entered search value" });
		} else {
			setError({ ...error, searchBy: "" });
		}
		const trimmedSearch = {};
		Object.keys(searchVehicle).forEach((key) => {
			if (typeof searchVehicle[key] === "string") {
				trimmedSearch[key] = searchVehicle[key].trim();
			} else {
				trimmedSearch[key] = searchVehicle[key];
			}
		});
		setSearchVehicle(trimmedSearch);
		filterRef.current = {
			...filterRef.current,
			...{ searchBy: Object.keys(searchVehicle), search: Object.values(trimmedSearch), start: new Date(Date.now() - 250 * 24 * 60 * 60 * 1000).toISOString, end: new Date().toISOString() },
		};
		if (Object.keys(searchVehicle).length > 0) {
			filterRef.current = { ...filterRef.current, plantId };
			setSearchTrigger(false);
			// trigger(filterRef.current);
			getTripDetail(filterRef.current);
		}
	};

	// console.log('checkpointData', checkpointData);
	useEffect(() => {
		if (entryId) {
			setLoading(true);
			getTripcheckpointTrigger({ type: "all", tripId: entryId })
				.unwrap()
				.then((res) => {
					// console.log('detail-chk', res.data);
					if (res?.error) {
						toastMessage(false, res.message);
					} else {
						setAllCheckpointList(res?.data || []);
					}
				})
				.catch((err) => {
					// console.log("err", err);
				})
				.finally(() => {
					setLoading(false);
				});
			vehicleDetailTrigger({ vehicleEntryId: entryId })
				.unwrap()
				.then((res) => {
					// console.log('detail-status-data', res.data.data);
					// console.log('detail-status', res.data.statusHistory);
					setVehicleData(res?.data || {});
					setSelectedVehicle(res?.data || {});
					setVehicleTableHeader(res?.tableHeader || []);
					setHistoricalDataHeaderMap(res?.historicalDataHeaderMap);
					// generateDetail(res.data, res.tableHeader)
				})
				.catch((err) => {
					// console.log("err", err);
				});
		}
	}, [entryId]);
	useEffect(() => {
		setSelectedVehicle({});
		setVehicleData({});
		setAllCheckpointList([]);
	}, [plantId]);
	useEffect(() => {
		if (location?.state?.data?._id) {
			handleVehicleDetail(location.state.data._id);
		}
	}, [location]);

	useEffect(() => {
		if (location.state?.selectedVehicle) {
			setSelectedVehicle(location.state.selectedVehicle);
			handleVehicleDetail(location.state.selectedVehicle._id);
		}
	}, [location.state]);
	const handleVehicleDetail = (id) => {
		setLoading(true);
		getTripcheckpointTrigger({ type: "all", tripId: id })
			.unwrap()
			.then((res) => {
				// console.log('detail-chk', res.data);
				if (res?.error) {
					toastMessage(false, res.message);
				} else {
					setAllCheckpointList(res?.data || []);
					setTripData(res?.data || []);
				}
			})
			.catch((err) => {
				// console.log("err", err);
			})
			.finally(() => {
				setLoading(false);
			});
		vehicleDetailTrigger({ vehicleEntryId: id })
			.unwrap()
			.then((res) => {
				// console.log('detail-status-data', res.data.data);
				// console.log('detail-status', res.data.statusHistory);
				setVehicleData(res?.data || {});
				setSelectedVehicle(res?.data || {});
				setVehicleTableHeader(res?.tableHeader || []);
				setHistoricalDataHeaderMap(res?.historicalDataHeaderMap);
				// generateDetail(res.data, res.tableHeader)
			})
			.catch((err) => {
				// console.log("err", err);
			});
	};

	const handleLogStatus = (status) => {
		let TempStatus = JSON.parse(JSON.stringify({ ...logStatus }));
		if (TempStatus.hasOwnProperty(status) && TempStatus[status] === true) {
			TempStatus[status] = false;
		} else {
			TempStatus[status] = true;
		}
		setLogStatus(TempStatus);
	};

	function flattenObj(res, obj = {}) {
		for (let key in obj) {
			if (Array.isArray(obj[key])) {
				if (obj[key].every((i) => isFilePath(i))) {
					res[key] = obj[key];
				} else if (obj[key].every((i) => typeof i == "string")) {
					res[key] = obj[key].join(",");
				} else if (obj[key].every((i) => typeof i === "object")) {
					if (obj[key].every((subObj) => typeof subObj[key + "Name"] === "string")) {
						// static hack for camelcase [key]Name array of objects
						res[key] = obj[key].reduce((p, c) => p + c[key + "Name"] + ", ", "").replace(/,\s*$/, "");
					}
				}
			} else if (typeof obj[key] == "object") {
				flattenObj(res, obj[key]);
			} else {
				res[key] = obj[key];
			}
		}
	}
	const generateDetail = (data, checkpointList) => {
		if (!data) return [];
		const newStaticDetail =
			checkpointList?.map((ele, index) => {
				const { order, checkpoints = [], optional, visited } = ele;
				let currChkpt = checkpoints[0];
				let checkPointStatus = checkpoints.map((ele, index) => (
					<div style={visited ? { backgroundColor: "var(--primary-color)" } : { backgroundColor: "var(--dark-gray-color)" }} className="status-clip" key={`checkpoint-key-${index}`}>
						{ele.displayName}
					</div>
				));
				const status = visited ? data.statusHistory.find((ele, index) => ele.checkpointId === checkpoints[0]._id) : null;
				const allStatus = visited ? data.statusHistory.filter((ele, index) => ele.checkpointId === checkpoints[0]._id) : null;
				let type;
				let isOfflinePacket = status?._basis == "offline-packet";
				let rows = [];

				let entry = data?.data?.find((_) => _.checkpointId == status?.checkpointId);
				const seen = new Set();
				let failsafe = 0;

				const { hideInTime = false, hideOutTime = false, inTimeLabel = "In Time", outTimeLabel = "Out Time" } = checkoutConfigMap[currChkpt?._id] || {};

				while (failsafe < 1000 && entry) {
					type = entry.type;
					let currentTableHeader = historicalDataHeaderMap[`${entry.checkpointId}-${entry.type}`];
					let row = [];
					if (currentTableHeader) {
						let dateStatus = allStatus.find((el) => el._id === entry._id);
						// const inTimeLabel = status?.checkpointType == "access" ? "Approval Request Time" : status?.checkpointType == "bay" ? "Dock Operation Start" : "In Time";
						// const outTimeLabel = status?.checkpointType == "access" ? "Approval Accepted Time" : status?.checkpointType == "bay" ? "Dock Operation End" : "Out Time";
						if (!hideInTime) {
							let inTime = formatDate(dateStatus?.inTime || status?.inTime);
							row.push(
								<div className="detail_row" key={inTime + currChkpt?._id + inTimeLabel}>
									<div className="detail_row_title">{inTimeLabel}</div>
									<div className="detail_row_value">{inTime}</div>
								</div>
							);
						}
						if (!hideOutTime) {
							let outTime = formatDate(dateStatus?.outTime || status?.outTime);

							row.push(
								<div className="detail_row" key={outTime + currChkpt?._id + outTimeLabel}>
									<div className="detail_row_title">{outTimeLabel}</div>
									<div className="detail_row_value">{outTime}</div>
								</div>
							);
						}
						currentTableHeader.forEach((header, i) => {
							let value = findDeepValue(entry, header.name?.split("."));
							if (value == "-") {
								value = findDeepValue(entry.formData, header.name?.split("."));
							}
							if (Array.isArray(value)) {
								value = new Array(...value);
							} else {
								value = String(value);
							}
							if (value && value != "-") {
								const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;
								if (new Date(value) != "Invalid Date" && isoPattern.test(value)) {
									value = formatDate(value);
								}
								row.push(
									<div className="detail_row" key={i}>
										<div className="detail_row_title">{header.label}</div>
										<div className="detail_row_value">
											{Array.isArray(value) ? (
												<span style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
													{value.map((el, i) => (isFilePath(el) ? <FilePreview key={i} fileKey={el} extension={String(el).split(".").pop()} /> : capitalizeCamelCase(el)))}
												</span>
											) : isFilePath(value) ? (
												<FilePreview fileKey={value} extension={value.split(".").pop()} />
											) : (
												capitalizeCamelCase(value)
											)}
										</div>
									</div>
								);
							}
						});
					} else {
						let rowData = {};
						flattenObj(rowData, entry.formData);
						let dateStatus = allStatus.find((el) => el._id === entry._id);
						// const findInTime = status?.checkpointType == "access" ? "Approval Request Time" : status?.checkpointType == "bay" ? "Dock Operation Start" : "In Time";
						// const findOutTime = status?.checkpointType == "access" ? "Approval Accepted Time" : status?.checkpointType == "bay" ? "Dock Operation End" : "Out Time";
						if (!hideInTime) {
							rowData[inTimeLabel] = formatDate(dateStatus?.inTime || status?.inTime);
						}
						if (!hideOutTime) {
							rowData[outTimeLabel] = formatDate(dateStatus?.outTime || status?.outTime);
						}
						if (status.type) {
							rowData["Type"] = status?.type;
						}
						delete rowData._id;
						delete rowData.vehicleId;
						for (let key in rowData) {
							let value = rowData[key];
							if (Array.isArray(value)) {
								value = new Array(...value);
							} else {
								value = String(value);
							}
							const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;
							if (new Date(value) != "Invalid Date" && isoPattern.test(value)) {
								value = formatDate(value);
							}
							row.push(
								<div className="detail_row" key={`${key}-${rowData[key]}`}>
									<div className="detail_row_title">{capitalizeSentence(parseUnderscore(capitalizeCamelCase(key)))}</div>
									<div className="detail_row_value">
										{Array.isArray(value) ? (
											<span style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
												{value.map((el, i) => (isFilePath(el) ? <FilePreview key={i} fileKey={el} extension={String(el).split(".").pop()} /> : capitalizeCamelCase(el)))}
											</span>
										) : isFilePath(value) ? (
											<FilePreview fileKey={value} extension={value.split(".").pop()} />
										) : (
											capitalizeCamelCase(value)
										)}
									</div>
								</div>
							);
						}
					}
					rows.push(row);
					seen.add(entry?._id);
					entry = data?.data?.find((_) => _.checkpointId == status?.checkpointId && !seen.has(_?._id));
					failsafe++;
				}
				const view = (
					<div key={index} className="statusHistory-container">
						<div className="statuslayout-container">
							<div className="status-connector-container">
								<div
									style={index === 0 ? { backgroundColor: "var(--background-color)" } : visited ? { backgroundColor: "green" } : { backgroundColor: "var(--dark-gray-color)" }}
									className="status-connector-line"
								></div>
								<div style={visited ? { backgroundColor: "green" } : { backgroundColor: "var(--dark-gray-color)" }} className="status-connector-circle">
									{visited && <CheckIcon fontSize={"small"} htmlColor={"#fff"} />}
								</div>
								<div
									style={
										index === checkpointList.length - 1
											? { backgroundColor: "var(--background-color)" }
											: visited
											? { backgroundColor: "green" }
											: { backgroundColor: "var(--dark-gray-color)" }
									}
									className="status-connector-line"
								></div>
							</div>
							<div className="status-checkpoint-container">{checkPointStatus}</div>
						</div>
						<div className="statusHistory-detail-content">
							<div style={{ fontWeight: "bold", textAlign: "center", color: "var(--text-color)", position: "relative" }}>
								{status?.displayName || ""}
								{type && `(${capitalizeCamelCase(type)})`}
								{isOfflinePacket ? <span className="offline-packet">Offline</span> : null}
							</div>
							{rows.length > 1 && (
								<div className="logbutton-div">
									<button onClick={() => handleLogStatus(status?.displayName)} className="logbutton">
										{logStatus[status?.displayName] ? "- " : "+ "}Show Full Status Log
									</button>
								</div>
							)}
							<div style={{ padding: "0.5rem", borderRadius: "12px", color: "var(--text-color)" }}>
								{logStatus[status?.displayName]
									? rows.map((row, i) =>
											row?.length ? <div key={i} style={{ border: "1px dotted var(--gray-color)", marginBottom: "10px", padding: "5px", borderRadius: "10px" }}>{row}</div> : null
									  )
									: [rows[rows?.length - 1]].map((row, i) =>
											row?.length ? (
												<div key={i}>{row}</div>
											) : (
												<div key={i} className="detail_row">
													<div className="detail_row_title">In Time</div>
													<div className="detail_row_value">-</div>
												</div>
											)
									  )}

								{currChkpt?.sendApproval ? <ApprovalStatus vehicleEntryDetail={data} checkpointDetail={currChkpt} historicalDataHeaderMap={historicalDataHeaderMap} /> : null}
							</div>
						</div>
					</div>
				);
				return view;
			}) || [];
		return <>{newStaticDetail}</>;
	};

	useEffect(() => {
		if (tripDataError && !isLoading) {
			toastMessage(false, message);
		}
	}, [isLoading]);
	//dynamic form
	const handleClose = () => {
		// console.log('handleClose called');
		setIsModifying(false);
		setForcedEndTrip(false);
		setCancelTrip(false);
	};
	const handleFormSubmit = (data) => {
		let payload;
		setIsSubmitting(true);
		if (isModifying) {
			payload = {
				vehicleEntryId: selectedVehicle._id,
				...data?.data,
			};
			// console.log("Form submitted", payload);
			modifyTripTrigger(payload)
				.unwrap()
				.then((res) => {
					if (res?.error) {
						return toastMessage(false, res.message);
					}
					// toastMessage(true, 'Trip Updated Successfully');
					toastMessage(true, res.message);
					setIsModifying(false);
					setForcedEndTrip(false);
					setCancelTrip(false);
					handleVehicleDetail(selectedVehicle._id);
					setSelectedVehicle({});
					setSearchVehicle("");
					setSearchTrigger(false);
					setIsSubmitting(false);
				})
				.catch((err) => {
					toastMessage(false, err.message);
				});
		} else {
			payload = {
				vehicleEntryId: selectedVehicle._id,
				// vehicleEntryId: selectedVehicle._id,
				forceEndTrip: forcedEndTrip,
				cancelTrip: cancelTrip,
				data: data.data,
			};

			updateManageTrip(payload)
				.unwrap()
				.then((res) => {
					setIsSubmitting(false);
					if (res?.error) {
						return toastMessage(false, res.message);
					}
					toastMessage(true, res.message);
					setIsModifying(false);
					setForcedEndTrip(false);
					setCancelTrip(false);
					handleVehicleDetail(selectedVehicle._id);
					// toastMessage(true, 'Trip Updated Successfully')
					setSelectedVehicle({});
					setSearchVehicle("");
					setSearchTrigger(false);
				})
				.catch((err) => {
					toastMessage(false, err.message);
				});
		}
	};
	const handleDialogOpen = () => {
		setIsOpen(true);
	};
	const onClose = () => {
		setIsOpen(false);
	};
	const handleTripWorkflowUpdate = async () => {
		const payload = {
			vehicleEntryId: selectedVehicle._id,
			checkpoints: tripData,
		};
		// console.log("Payload", payload)
		await updateCustomizeTripWorkflow(payload)
			.unwrap()
			.then((res) => {
				if (res.error == true) {
					toastMessage(false, res.message);
				} else {
					toastMessage(true, res.message);
					onClose();
				}
			})
			.catch((err) => {
				toastMessage(false, err.message);
			});
	};
	function generateFormType() {
		if (isModifying) return { title: "Modify Trip", template: "modifyTrip" };
		if (cancelTrip) return { title: "Cancel Trip", template: "cancelTrip" };
		if (forcedEndTrip) return { title: "Force End Trip", template: "forceEndTrip" };
		return { title: "Vehicle Detail", template: "" };
	}

	return (
		<>
			<div className="contentpanel" onClick={() => (!searchTrigger ? setSearchTrigger(true) : null)}>
				<div className="cust-row flex-algn-cent">
					<div className="cust-col-5">
						<h1 className="title">Manage Trip</h1>
					</div>
					<div className="cust-col-5 flex-jc-end gap-3"></div>
				</div>
				<hr className="bgg" />
				<div className="trip-search-section">
					<div className="trip-search-section-left">
						<SearchDropdown
							id={"vehicleNumber"}
							name={"vehicleNumber"}
							options={[
								{ label: "Vehicle Number", value: "vehicleNumber" },
								{ label: "Trip ID", value: "trip_counter" },
							]}
							preSelectedOption={{ label: "Vehicle Number", value: "vehicleNumber" }}
							label={"Search by"}
							placeholder={"Enter value"}
							value={searchVehicle}
							Debounce={true}
							textBorderRadius="1px 0px 0px 1px"
							selectBorderRadius="20px 1px 1px 20px"
							adornment={{
								is: true,
								onClick: () => {
									setSearchTrigger(true);
									setSearchVehicle("");
								},
								type: isLoading ? "loader" : "CloseIcon",
							}}
							onDropdownChange={onhandleClear}
							onChange={(value, key) => handleChange(value, key)}
							onhandleClear={onhandleClear}
						/>
						<div style={{ textAlign: "start" }}>{error?.searchBy ? <span style={{ color: "var(--red-color)", fontSize: "12px" }}>{error.searchBy}</span> : null}</div>
						<div>
							{!searchTrigger && tripDetail?.length > 0 ? (
								<div className={"trip-search-section-left-list"}>
									<ul>
										{tripDetail.map((ele, index) => (
											<li
												className={ele._id === selectedVehicle._id ? "active" : null}
												key={ele._id}
												onClick={() => {
													// console.log('selected vehicle', ele)
													handleVehicleDetail(ele._id);
												}}
											>
												<span style={{ fontSize: "14px", fontWeight: "bold" }}>Vehicle No.</span>
												<span style={{ fontSize: "14px" }}>{ele.vehicleNumber}</span>
												<span style={{ fontSize: "14px", fontWeight: "bold" }}>, Trip ID : </span>
												<span style={{ fontSize: "14px" }}>{`${ele.trip_counter}`}</span>
											</li>
										))}
									</ul>
								</div>
							) : null}
						</div>
					</div>
					<div className="trip-search-section-right">
						<Button
							text={<SearchIcon />}
							style={{ ...buttonClasses.lynkitOrangeFill, height: "45px", minWidth: "45px", borderRadius: "50%", transform: "Translate(-12px, -3px)" }}
							onClick={() => {
								onHandleSearch();
							}}
						/>
					</div>
				</div>
				{loading ? (
					<Loader size="2rem" />
				) : Object.keys(vehicledata).length > 0 ? (
					<div className="trip-detail-section">
						<div className="trip-detail-container">
							<div className="trip-detail-header">
								<h4>{generateFormType()?.title}</h4>
							</div>

							<div className="trip-button-container">
								{userPermissions?.modifyTrip?.value && !(isModifying || forcedEndTrip || cancelTrip) && !selectedVehicle?.trip_over && (
									<Button
										onClick={() => setIsModifying(!isModifying)}
										text="Modify Trip"
										style={{ ...buttonClasses.lynkitOrangeFill, height: "36px", marginRight: "10px", width: "150px" }}
									/>
								)}
								{userPermissions?.cancelTrip?.value && !(isModifying || forcedEndTrip || cancelTrip) && !selectedVehicle?.trip_over && (
									<Button
										text="Cancel Trip"
										style={{ ...buttonClasses.lynkitOrangeFill, height: "36px", marginRight: "10px", width: "150px" }}
										onClick={() => {
											setCancelTrip(true);
										}}
									/>
								)}
								{userPermissions?.forceEndTrip?.value && !(isModifying || forcedEndTrip || cancelTrip) && !selectedVehicle?.trip_over && (
									<Button
										text="Force End Trip"
										style={{ ...buttonClasses.lynkitOrangeFill, height: "36px", marginRight: "10px", width: "150px" }}
										onClick={() => {
											setForcedEndTrip(true);
										}}
									/>
								)}
								{userPermissions?.viewTripMap?.value && factoryCoordinatesValue && (
									<Button
										// onClick={() => handleOpenNewTab(selectedVehicle._id)}
										// onClick={()=>navigate(`/map-view?data=${encodeURIComponent(selectedVehicle._id)}`)}
										onClick={() => navigate(`/map-view`, { state: { selectedVehicle, factoryCoordinatesValue: factoryCoordinatesValue } })}
										// text="View On Map"
										style={{ ...buttonClasses.lynkitOrangeFill, height: "36px", marginRight: "10px", width: "150px" }}
									>
										<LocationOnIcon />
										View On Map
									</Button>
								)}
								{userPermissions?.customizeTripWorkflow?.value && tripData.length > 0 && !tripData[tripData.length - 1]?.visited && (
									<Button style={{ ...buttonClasses.lynkitOrangeFill, height: "36px", marginRight: "10px", width: "190px" }} onClick={handleDialogOpen}>
										Customize Trip WorkFlow
									</Button>
								)}
							</div>
							{isOpen && (
								<>
									<Dialog
										size="lg"
										open={true}
										handleSubmit={handleTripWorkflowUpdate}
										handleClose={() => {
											// setLabelDetail(labelData);
											onClose();
										}}
										handleCancel={onClose}
										title={"Customize Trip Workflow"}
										SubmitText={"Update"}
									>
										<GenericWorkflowUpdate tripData={tripData} workflowData={tripData} setWorkflowData={setTripData} />
									</Dialog>
								</>
							)}
							{isModifying || forcedEndTrip || cancelTrip ? (
								<>
									<div style={{ padding: "0px 20px" }}>
										{isModifying && (
											<div>
												<p
													style={{ color: "var(--red-color)", fontSize: "14px" }}
												>{`**Note: Once you click Submit the trip the current trip with ID ${selectedVehicle?.trip_counter} will be concluded, and the timestamp for this action will be recorded as the current time for upcoming checkpoints of current trip.`}</p>
											</div>
										)}
										<DynamicFormRender
											templatePayload={{
												organization_id: userDetail.orgId,
												template_name: generateFormType()?.template,
												type: generateFormType()?.template,
											}}
											checkoutData={{ trip_counter: vehicledata.trip_counter, vehicleNumber: vehicledata.vehicleNumber }}
											onClose={handleClose}
											onSubmit={handleFormSubmit}
											isSubmitDisabled={isSubmitting}
										/>
									</div>
								</>
							) : (
								<>
									<div className="trip-detail-content">
										{vehicleTableHeader.length > 0 &&
											vehicleTableHeader.map((ele, index) => (
												<div key={index} className="trip-detail-content-field">
													<div
														style={isModifying && (ele.label == "Product" || ele.label == "Product Category") ? { paddingTop: "5px" } : {}}
														className="trip-detail-content-field-label"
													>
														<span>{ele.label} :</span>
													</div>
													<div className="trip-detail-content-field-value">
														{isModifying && (ele.label == "Product" || ele.label == "Product Category") ? (
															<span>
																<Dropdown
																	id={ele.label}
																	name={ele.label == "Product" ? "product" : ele.label == "Product Category" ? "productCategory" : null}
																	value={null}
																	options={[]}
																	label={ele.label}
																	// onChange={(option, key) => onHandleCheckpointDetailChange(option, key)}
																	// error={error?.checkPoint?.orgId}
																/>
															</span>
														) : (
															<span>
																{ele.type == "date" ? formatDate(findDeepValue(vehicledata, ele.name.split("."))) : findDeepValue(vehicledata, ele.name.split("."))}
															</span>
														)}
													</div>
												</div>
											))}
									</div>
									<div>{allCheckpointList.length > 0 && vehicleTableHeader.length > 0 && generateDetail(vehicledata, allCheckpointList)}</div>
								</>
							)}
						</div>
					</div>
				) : (
					<>
						<AllCheckpointData listOnly noSocketEvent={true} />
					</>
				)}
				{/* {Object.keys(selectedVehicle).length > 0 && !selectedVehicle?.trip_over && !isModifying ? (
					<div className="trip-button-section">
						{userPermissions?.cancelTrip?.value && (
							<div>
								{!cancelTrip ? (
									<Button
										text="Cancel Trip"
										style={{ ...buttonClasses.lynkitOrangeFill, height: "40px", marginRight: "10px" }}
										onClick={() => {
											setCancelTrip(true);
											setForcedEndTrip(false);
											setRemarks("");
											setError({ ...error, remarks: "" });
										}}
									/>
								) : (
									<div className="trip-cancel-section">
										<div>
											<Input
												id={"remark"}
												name={"remark"}
												value={remarks}
												onChange={(e) => {
													setRemarks(e.target.value);
												}}
												label={"Remarks"}
												placeholder={"Enter Remarks"}
												required={true}
												error={error?.remarks}
											/>
										</div>
										<div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
											<Button
												text="Submit"
												style={{ ...buttonClasses.lynkitOrangeFill, height: "40px", marginRight: "10px" }}
												onClick={() => {
													onHandleTrip();
												}}
											/>
										</div>
									</div>
								)}
							</div>
						)}
						{userPermissions?.forceEndTrip?.value && (
							<div>
								{!forcedEndTrip ? (
									<Button
										text="Force End Trip"
										style={{ ...buttonClasses.lynkitOrangeFill, height: "40px" }}
										onClick={() => {
											setForcedEndTrip(true);
											setCancelTrip(false);
											setRemarks("");
											setError({ ...error, remarks: "" });
										}}
									/>
								) : (
									<div className="trip-cancel-section">
										<div>
											<Input
												id={"remark"}
												name={"remark"}
												value={remarks}
												onChange={(e) => {
													setRemarks(e.target.value);
												}}
												label={"Remarks"}
												placeholder={"Enter Remarks"}
												required={true}
												error={error?.remarks}
											/>
										</div>
										<div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
											<Button
												text="Submit"
												style={{ ...buttonClasses.lynkitOrangeFill, height: "40px", marginRight: "10px" }}
												onClick={() => {
													onHandleTrip();
												}}
											/>
										</div>
									</div>
								)}
							</div>
						)}
					</div>
				) : null} */}
			</div>
		</>
	);
}

function ApprovalStatus({ vehicleEntryDetail, checkpointDetail, historicalDataHeaderMap }) {
	const { userDetail } = useUserDetail();

	const [getApprovalDetail, { data: approvalDetailData, isLoading: isApprovalDetailLoading }] = useGetApprovalDetailMutation();
	const { data: approvalDetails = [] } = approvalDetailData || { data: [] };

	const [getApprovalConfig, { data: approvalConfigData, isLoading: isApprovalConfigLoading }] = useGetApprovalConfigMutation();
	const { data: approvalConfig } = approvalConfigData || { data: [] };

	useEffect(() => {
		if (checkpointDetail) {
			getApprovalDetail({ reference_id: vehicleEntryDetail._id, module: checkpointDetail.checkpointStatus });

			const currentCheckpointEntry = vehicleEntryDetail.statusHistory.find((_) => _.checkpointId == checkpointDetail._id);
			// console.log("currentCheckpointEntry", currentCheckpointEntry)
			if (currentCheckpointEntry?.currentApprovalConfig) {
				getApprovalConfig({ id: currentCheckpointEntry.currentApprovalConfig });
			}
			// let { sendApproval, dependentApproval, approvaldependancy = [], approvalId } = checkpointDetail;
			// if (sendApproval && !dependentApproval) {
			// 	// the approval config selected will always be the approvalId outside
			// 	if (approvalId) {
			// 		// get approval config of this id
			// 		getApprovalConfig({ id: approvalId });
			// 	} else {
			// 		// toastMessage(false, "There is no Approval Config defined for this checkpoint");
			// 	}
			// } else if (sendApproval && dependentApproval) {
			// 	// now we will check the approvalDependancy
			// 	// for each approvalInfo in the approvalDependancy, we will check the itemType and id array and compare it with the data that matches the itemType in the vehicle entry details
			// 	// if the particular id exists in the data, then we will take the corresponding approvalId
			// 	approvaldependancy.forEach((item) => {
			// 		let dataItem = vehicleEntryDetail[item.itemType];
			// 		if (dataItem) {
			// 			// console.log(dataItem, checkpointDetail)
			// 			if (Array.isArray(dataItem)) {
			// 				if (item.itemType == "product" && !item.approvalId) {
			// 					// special case here is the product
			// 					// for Haier, we have product priority usecase
			// 					// so simply, there doesn't exist any approvalConfig, so there won't be any approvalId. In that case, we will simply show whatver approval details exists
			// 				} else if (dataItem.find((_) => item.id.includes(_._id))) {
			// 					// item.approvalId
			// 					if (item.approvalId) {
			// 						// console.log("data item array")
			// 						getApprovalConfig({ id: item.approvalId });
			// 					} else {
			// 						// toastMessage(false, "There is no Approval Config defined for this checkpoint");
			// 					}
			// 				}
			// 			} else {
			// 				if (item.id.includes(dataItem._id)) {
			// 					// item.approvalId
			// 					if (item.approvalId) {
			// 						// console.log("data item", item);
			// 						getApprovalConfig({ id: item.approvalId });
			// 					} else {
			// 						// toastMessage(false, "There is no Approval Config defined for this checkpoint");
			// 					}
			// 				}
			// 			}
			// 		}
			// 	});
			// }
		}
	}, [vehicleEntryDetail]);

	let approvalsUi = [];

	let approvalLayers = [];

	if (approvalConfig?.length) {
		let approval_details = JSON.parse(JSON.stringify(approvalDetails || []));

		approvalConfig[0]?.approval_layer?.forEach((approval_layer, i) => {
			let approvalDetail;
			let approvalIndex;
			for (let i = 0; i < approval_details.length; i++) {
				let item = approval_details[i];

				if (item.approval_detail) {
					if (item.approval_detail?.email == approval_layer.user_details?.email || item.approval_detail.userRole == approval_layer.role) {
						approvalIndex = i;
						break;
					}
				} else {
					if (item.nextApprovalDetails?.find((_) => _.email == approval_layer.user_details?.email || _.userRole == approval_layer.role)) {
						approvalIndex = i;
						break;
					}
				}
			}

			approvalDetail = approval_details[approvalIndex];
			approval_details.splice(approvalIndex, 1);

			// approvalDetail = approvalDetails?.find((item) => {
			// 	if (item.approval_detail) {
			// 		if (approval_layer.require_user_approval) {
			// 			return item.approval_detail.email == approval_layer.user_details?.email;
			// 		} else {
			// 			return item.approval_detail.userRole == approval_layer.role;
			// 		}
			// 	} else {
			// 		return !!item.nextApprovalDetails?.find((_) => _.email == approval_layer.user_details?.email);
			// 	}
			// });
			let approver_detail =
				approvalDetail?.approval_detail || approvalDetail?.nextApprovalDetails?.find((_) => _.email == approval_layer.user_details?.email || _.userRole == approval_layer.role);

			let canApprove = false;
			if (!approvalDetail || approvalDetail.isRejected) {
				if (approver_detail?.id == userDetail?.userId || (!approval_layer.require_user_approval && approval_layer.role_id == userDetail?.userRoleId)) {
					canApprove = true;
				}
				if (canApprove) {
					canApprove = !approvalConfig[0].approval_layer?.some((el, j) => j < i && el.approval_require && (!approvalDetail || approvalDetail.isRejected));
				}
			}
			approvalLayers.push({
				user: approval_layer.require_user_approval ? approval_layer.user_details?.name : approval_layer.role,
				status: getApprovalStatus(approvalDetail),
				canApprove,
				formData: approvalDetail?.formData,
				approvalTableHeader: historicalDataHeaderMap[`${approvalDetail?.approvalTemplateId}-approval`],
				id: approval_layer._id,
			});
		});
	} else if (approvalDetails?.length) {
		approvalDetails?.forEach((approvalDetail, i) => {
			// let canApprove = false;
			// if (!approvalDetail || approvalDetail.isRejected) {
			// 	if (approvalDetail?.approval_detail.id == userDetail?.userId || (!_.require_user_approval && _.role_id == userDetail?.userRoleId)) {
			// 		canApprove = true;
			// 	}
			// 	if (canApprove) {
			// 		canApprove = !approvalConfig[0].approval_layer?.some((el, j) => j < i && el.approval_require && (!approvalDetail || approvalDetail.isRejected));
			// 	}
			// }

			approvalLayers.push({
				user: approvalDetail.approval_detail?.name || approvalDetail.approval_detail?.email || approvalDetail.approval_detail?.userRole,
				status: getApprovalStatus(approvalDetail),
				canApprove: false,
				formData: approvalDetail.formData,
				approvalTableHeader: historicalDataHeaderMap[`${approvalDetail.approvalTemplateId}-approval`],
				id: approvalDetails._id,
			});
		});
	}
	const [approvalFormId, setApprovalFormId] = useState("");
	approvalsUi = approvalLayers.map((_, i) => {
		return (
			<div key={i} className={`approval_status_item ${_.status == "Approved" ? "approved" : _.status == "Rejected" ? "rejected" : "pending"}`}>
				<div className="status-connector-circle">
					{_.status == "Approved" ? <CheckIcon fontSize={"small"} htmlColor={"#fff"} /> : _.status == "Rejected" ? <CloseIcon fontSize="small" htmlColor="#fff" /> : null}
				</div>
				<div style={{ textAlign: "center" }}>
					<div>Status : {_.status}</div>
					<div>{_.user}</div>
				</div>
				{/* <Button text="Approve" disabled={!_.canApprove} /> */}
				{_.formData ? (
					<Button
						style={buttonClasses.lynkitBlackFill}
						text="View Form Data"
						onClick={() => {
							setApprovalFormId(_.id);
						}}
					/>
				) : null}
				{approvalFormId == _.id ? (
					<Dialog title="Approval Form Data" open={true} handleClose={() => setApprovalFormId("")} noBtn>
						{_.approvalTableHeader?.length
							? _.approvalTableHeader.map((header, i) => {
									let value = findDeepValue(_.formData, header.name?.split("."));
									if (Array.isArray(value)) {
										value = new Array(...value);
									} else {
										value = String(value);
									}
									const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;
									if (new Date(value) != "Invalid Date" && isoPattern.test(value)) {
										value = formatDate(value);
									}
									return (
										<div className="detail_row" key={i}>
											<div className="detail_row_title">{header.label}</div>
											<div className="detail_row_value">
												{Array.isArray(value) ? (
													<span style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
														{value.map((el, i) =>
															isFilePath(el) ? <FilePreview key={i} fileKey={el} extension={String(el).split(".").pop()} /> : capitalizeCamelCase(el)
														)}
													</span>
												) : isFilePath(value) ? (
													<FilePreview fileKey={value} extension={value.split(".").pop()} />
												) : (
													capitalizeCamelCase(value)
												)}
											</div>
										</div>
									);
							  })
							: Object.keys(_.formData).map((key, i) => {
									let value = _.formData[key];
									if (Array.isArray(value)) {
										value = new Array(...value);
									} else {
										value = String(value);
									}
									const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;
									if (new Date(value) != "Invalid Date" && isoPattern.test(value)) {
										value = formatDate(value);
									}
									return (
										<div className="detail_row" key={i}>
											<div className="detail_row_title">{capitalizeSentence(parseUnderscore(capitalizeCamelCase(key)))}</div>
											<div className="detail_row_value">
												{Array.isArray(value) ? (
													<span style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
														{value.map((el, i) =>
															isFilePath(el) ? <FilePreview key={i} fileKey={el} extension={String(el).split(".").pop()} /> : capitalizeCamelCase(el)
														)}
													</span>
												) : isFilePath(value) ? (
													<FilePreview fileKey={value} extension={value.split(".").pop()} />
												) : (
													capitalizeCamelCase(value)
												)}
											</div>
										</div>
									);
							  })}
					</Dialog>
				) : null}
			</div>
		);
	});

	let statusUi = <div className="approval_status_wrap">{isApprovalConfigLoading || isApprovalDetailLoading ? <Loader size="1rem" /> : approvalsUi}</div>;

	return statusUi;
}
function getApprovalStatus(approvalDetail) {
	return approvalDetail
		? approvalDetail.approvalStatus?.toLowerCase() == "hold"
			? "Hold"
			: approvalDetail.approvalStatus.includes("moveTo")
			? "Move To"
			: approvalDetail.approvalStatus?.toLowerCase() == "pending"
			? "Pending"
			: approvalDetail.isRejected
			? "Rejected"
			: "Approved"
		: "Pending";
}
